import PropTypes from 'prop-types'
import { createSelector } from 'reselect'

import Config from '../classes/Config'
import {
  DefaultTopicSegmentsState
} from '../reducers/topicSegments_reducer'

// -----------------------------------------------------------------------------

// Topic Plan Segments Selectors

// -----------------------------------------------------------------------------

/* Fetches the segments by id, assuming an id is in the url */
const getTopicSegments = (state, props) => {
  let topicId = null
  if (props.shortcut && props.shortcut.target_id) {
    topicId = props.shortcut.target_id
  } else {
    topicId = props.match.params.topicId
  }
  return (state.topics.byId[topicId] || {}).segments
}

/* Smartly returns the segments or the default state */
const getTopicSegmentsState = createSelector(
  [getTopicSegments],
  (segments) => {
    return segments || DefaultTopicSegmentsState
  }
)

const TopicSegmentsPropType = PropTypes.shape({
  rank: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
})

const makeTopicPlanSegments = () => {
  return createSelector(
    [getTopicSegmentsState],
    (segments) => {
      let topN = ((segments.details || {}).segments || [])
          .sort((a, b) => (b.percent_users - a.percent_users) || (a.segment - b.segment))
          .slice(0, Config.NumSegmentsToShow)
      let data = topN.map(item => {
        return {
          segment: item.segment,
          attributes: item.attributes,
          percentage: item.percent_users * 100 // convert to %
        }
      })
      return {
        isFetching: segments.isFetching || segments.didInvalidate || !segments.details,
        error: segments.error,
        details: data
      }
    }
  )
}

// -----------------------------------------------------------------------------

// Exports

// -----------------------------------------------------------------------------

export {
  makeTopicPlanSegments,
  TopicSegmentsPropType
}
